/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2020-12-08 13:47:51
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2025-12-18 13:39:22
 * @FilePath: \newmall\src\store\getters.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

const getters = {
  token: state => state.user.token,
  location: state => state.location.locationInfo,
  userInfo: state => state.user.userInfo,
  userInte: state => state.user.userInte,
  userSurplus: state => state.user.userSurplus,
  searchHistory: state => state.search.histories,
  mainPlatform: state => {
    return state.user.mianPlatform
  },
  paltShopId: state => {
    return state.user.paltShopId
  },
  welfareCards: state => {
    return state.user.welfareCards || []
  }
}

export default getters
